import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { BlastHowComponent } from 'src/app/components/blast/blast-how/blast-how.component';
import { BlastTipsComponent } from 'src/app/components/blast/blast-tips/blast-tips.component';
import { BlastCreditCalculatorComponent } from 'src/app/components/blast/credit/blast-credit-calculator/blast-credit-calculator.component';
import { BlastCreditListComponent } from 'src/app/components/blast/credit/blast-credit-list/blast-credit-list.component';
import { BlastPackageComponent } from 'src/app/components/blast/credit/blast-package/blast-package.component';

import { BlastTemplateManageComponent } from 'src/app/components/blast/template/blast-template-manage/blast-template-manage.component';
import { BlastCredit, BlastUsage } from 'src/app/interfaces/blast';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { AccountPackageService } from 'src/app/services/account/account-package.service';
import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { BlastCreditService } from 'src/app/services/blast/blast-credit.service';
import { BlastMigrateService } from 'src/app/services/blast/blast-migrate.service';
import { BlastMsgService } from 'src/app/services/blast/blast-msg.service';
import { BlastNoticeService } from 'src/app/services/blast/blast-notice.service';
import { BlastResumeService } from 'src/app/services/blast/blast-resume.service';
import { BlastTemplateService } from 'src/app/services/blast/blast-template.service';
import { BlastUsageService } from 'src/app/services/blast/blast-usage.service';
import { CurrencyService } from 'src/app/services/general/currency.service';
import { LinkService } from 'src/app/services/general/link.service';
import { LocalityService } from 'src/app/services/location/locality.service';
import { SmsMigrateService } from 'src/app/services/sms/sms-migrate.service';

import { BlastCreditType, BlastType } from 'src/app/types/blast';

@Component({
  selector: 'app-blast-home',
  templateUrl: './blast-home.page.html',
  styleUrls: ['./blast-home.page.scss'],
})
export class BlastHomePage implements OnInit, OnDestroy {

  currency: string;

  ready: boolean;

  trialMode: boolean;

  smsMigrate: boolean;

  blastUsageList: BlastUsage[];
  blastCreditList: BlastCredit[];

  private blastUsageSubscription: Subscription;
  private blastCreditSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private accountInfoService: AccountInfoService,
    private accountPackageService: AccountPackageService,
    private blastCreditService: BlastCreditService,
    private blastMigrateService: BlastMigrateService,
    private blastUsageService: BlastUsageService,
    private blastResumeService: BlastResumeService,
    private privilegeService: PrivilegeService,
    private currencyService: CurrencyService,
    private localityService: LocalityService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  ionViewWillEnter() {
    this.currency = this.currencyService.getStripeCurrency()?.code;
    this.ready = true;
    this.watch();
    if (!this.accountPackageService.accountPackage?.accountStatus?.premium && this.accountPackageService.accountPackage?.accountStatus?.trial) {
      this.trialMode = true;
    } else {
      this.trialMode = false;
    }
  }

  ionViewDidEnter() {
    this.blastResumeService.checkBlastResumeData();
  }

  ionViewWillLeave() {
    this.ready = false;
    this.unwatch();
  }

  async upgradeBlastDb() {
    await this.blastMigrateService.upgrade();
  }

  readSms() {
    // this.smsTemplateService.readSmsTemplateList();
    // this.smsTemplateService.readSmsTemplateSetting();
    // this.smsCreditService.readSmsCreditList();
    // this.smsMsgService.readSmsMsgList();
    // this.smsUsageService.readSmsUsage();
  }

  watch() {
    this.watchBlastCredit();
    this.watchBlastUsage();
    // this.blastTemplateService.watch();
    // this.blastUsageService.watchUsage();
    // this.blastMsgService.watchBlastMsgList();
    // this.blastCreditService.watchBlastCreditList();
  }

  unwatch() {
    this.unwatchBlastCredit();
    this.unwatchBlastUsage();
    // this.blastTemplateService.unwatch();
    // this.blastUsageService.unwatchUsage();
    // this.blastMsgService.unwatchBlastMsgList();
    // this.blastCreditService.unwatchBlastCreditList();
  }

  watchBlastUsage() {
    if (!this.blastUsageSubscription) {
      this.blastUsageSubscription = this.blastUsageService.observableBlastUsage.subscribe((blastUsageList: BlastUsage[]) => {
        this.blastUsageList = blastUsageList;
      })
    }
  }

  watchBlastCredit() {
    if (!this.blastCreditSubscription) {
      this.blastCreditSubscription = this.blastCreditService.observableBlastCredit.subscribe((blastCreditList: BlastCredit[]) => {
        this.blastCreditList = blastCreditList;
      })
    }
  }

  unwatchBlastUsage() {
    if (this.blastUsageSubscription) {
      this.blastUsageSubscription.unsubscribe();
      this.blastUsageSubscription = null;
    }
  }

  unwatchBlastCredit() {
    if (this.blastCreditSubscription) {
      this.blastCreditSubscription.unsubscribe();
      this.blastCreditSubscription = null;
    }
  }

  checkPrivilege(action: string): boolean {
    return this.privilegeService.checkCurrentUserPrivilege('blast', action);
  }

  async presentBlastTipsModal() {
    const modal = await this.modalController.create({
      component: BlastTipsComponent,
      componentProps: {
      }
    });
    modal.present();
  }

  async presentBlastHowModal() {
    const modal = await this.modalController.create({
      component: BlastHowComponent,
      componentProps: {
      }
    });
    modal.present();
  }
  
  async presentTemplateManageModal(blastType: BlastType) {
    const modal = await this.modalController.create({
      component: BlastTemplateManageComponent,
      componentProps: {
        blastType,
        hideBlastType: true,
      }
    });
    modal.present();
  }

  // async presentTemplateListModal() {
  //   const modal = await this.modalController.create({
  //     component: BlastTemplateListComponent,
  //     componentProps: {
  //       selectMode: true
  //     }
  //   });
  //   modal.present();
  // }

  async presentBlastCreditListModal(blastCreditType: BlastCreditType) {
    const modal = await this.modalController.create({
      component: BlastCreditListComponent,
      componentProps: {
        blastCreditType
      }
    });
    modal.present();
  }

  async presentBlastPackageModal() {
    const modal = await this.modalController.create({
      component: BlastPackageComponent,
      componentProps: {
      }
    });
    modal.present();
  }

  async presentBlastCreditCalculatorModal() {
    const modal = await this.modalController.create({
      component: BlastCreditCalculatorComponent,
      cssClass: '',
      componentProps: {
      }
    });
    modal.present();
  }

  checkBlastNoticeCountry(): boolean {
    const country = this.localityService.getAccountCountry()?.code;
    if (country === 'MY' || country === 'SG' || country === 'US') {
      return true;
    }
    return false;
  }

  getBlastCreditList() {
    return this.blastCreditService.blastCreditList;
  }

  getBlastUsageList() {
    return this.blastUsageService.blastUsageList;
  }


  goBlastHelpPage() {
    this.linkService.goHelpCenter();
  }

  async goUpgrade() {
    this.accountInfoService.goUpgradeSubscriptionPage();
  }

}
